(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.product-page').forEach(function(page) {
    var quantity = page.querySelector('input[name="quantity"]');
    var minus = page.querySelector('[data-quantity-minus]');
    var plus = page.querySelector('[data-quantity-plus]');
    if (quantity && minus && plus) {
      minus.addEventListener('click', function(){ quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
      plus.addEventListener('click', function(){ quantity.value = Number(quantity.value || 1) + 1; });
    }
    var share = page.querySelector('[data-share-product]');
    var status = page.querySelector('[data-share-status]');
    if (share && status) share.addEventListener('click', function(){
      if (navigator.share) navigator.share({title: document.title, url: window.location.href}).catch(function(){});
      else navigator.clipboard.writeText(window.location.href).then(function(){ status.textContent = 'Link copied to your clipboard.'; });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
